import { SelectForm } from "components";
import ErrorHelper from "helpers/ErrorHelper";
import { useDataModel } from "hooks/useDataModel";
import { Concessionaire } from "models/Concessionaire";
import { useEffect, useMemo, useRef, useState } from "react";
import { toast } from "react-toastify";
import { ConcessionaireService } from "services/concessionaireService";
import { StepLoading } from "../layout";
import { ApplicationFields, ApplicationFormik } from "../types";

export default function ConcessionaireStep({
	formik,
	onConcessionaireChange
}: ApplicationFormik & {
	onConcessionaireChange: (e: any) => void;
}) {
	const [isLoadingConcessionaire, setIsLoadingConcessionaire] = useState(true);

	const concessionaireService = useMemo(ConcessionaireService.getInstance, []);
	const [concessionaires, setConcessionaires] = useState<Concessionaire[] | null>(null);

	const { concessionaire } = formik.values;

	useEffect(() => {
		setIsLoadingConcessionaire(true);
		concessionaireService
			.listAll()
			.then((response) => {
				setConcessionaires(response);
			})
			.catch((e) => toast.error(ErrorHelper.getResponseErrorMessage(e)))
			.finally(() => setIsLoadingConcessionaire(false));
	}, []);

	const selectedConcessionaire = useDataModel(concessionaire, Concessionaire);

	const selectContainerRef = useRef<HTMLDivElement | null>(null);

	return (
		<div className="relative h-full flex">
			<div className="max-md:col-span-full overflow-y-auto overflow-x-hidden w-full" ref={selectContainerRef}>
				<div className="m-6 flex flex-col gap-6">
					<div className="flex flex-col w-full">
						<h1 className="mb-6 md:my-2 md:p text-2xl font-semibold md:text-lg md:font-normal ">
							Para qual a concessionária você deseja solicitar a isenção
						</h1>
						<div className="flex flex-col gap-4">
							{isLoadingConcessionaire ? (
								<StepLoading />
							) : (
								<SelectForm
									options={concessionaires?.map((type) => type.toOption())}
									name={ApplicationFields.concessionaire}
									label="Concessionária"
									value={selectedConcessionaire?.toOption()}
									onChange={onConcessionaireChange}
									setFieldValue={formik.setFieldValue}
									useOuterScroll
									menuPosition="absolute"
									menuPlacement="bottom"
									onMenuClose={() =>
										selectContainerRef.current?.scroll({
											top: 0
										})
									}
									noOptionsMessage="Nenhuma concessionária encontrada"
									error={formik.errors.concessionaire}
									touched={formik.touched.concessionaire}
								/>
							)}
						</div>
					</div>
				</div>
			</div>
		</div>
	);
}
